import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo, useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
const ColorModeContext = createContext({ toggleColorMode: () => { } });
export const useColorMode = () => useContext(ColorModeContext);
export const ThemeContextProvider = ({ children }) => {
    const [mode, setMode] = useState('light');
    const colorMode = useMemo(() => ({
        toggleColorMode: () => {
            setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
        },
    }), []);
    const theme = useMemo(() => createTheme({
        palette: {
            mode,
        },
    }), [mode]);
    return (_jsx(ColorModeContext.Provider, { value: colorMode, children: _jsx(ThemeProvider, { theme: theme, children: children }) }));
};
